import { Component, inject, OnInit } from '@angular/core';
import { AdminNotificationsComponent } from '../../../components/admin-dashboard-component/admin-notifications-component/admin-notifications-component';
import { NotificationService } from '../../../services/notifications/notifications.service';
import { NotificationType } from '../../../components/admin-dashboard-component/header/header.model';

@Component({
  selector: 'app-admin-notifications',
  imports: [AdminNotificationsComponent],
  templateUrl: './admin-notifications.html',
  styleUrl: './admin-notifications.scss',
})
export class AdminNotifications {}
